import { render } from "./BackOfficeFilmInfo.vue?vue&type=template&id=582c1548&scoped=true"
import script from "./BackOfficeFilmInfo.vue?vue&type=script&lang=js"
export * from "./BackOfficeFilmInfo.vue?vue&type=script&lang=js"

import "./BackOfficeFilmInfo.vue?vue&type=style&index=0&id=582c1548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582c1548"]])

export default __exports__